import InformationCards from "./InformationCards";

export default InformationCards; 